import { getVideoStoragePrefix } from "../config/video";
import { resolveFastTranslateMediaUrl } from "./videoUrl";

const toAbsoluteUrl = (rawUrl: string | null | undefined, prefix: string): string => {
  if (!rawUrl) return "";
  if (rawUrl.startsWith("http://") || rawUrl.startsWith("https://")) return rawUrl;
  return `${prefix}${rawUrl.startsWith("/") ? rawUrl : `/${rawUrl}`}`;
};

/**
 * 将一键速译 item/list 接口数据转为与多语种列表一致的 Task.TaskItem，
 * 与 VideoList 中 fromQuick 分支逻辑保持一致（含 cosStatus → status、播放 URL 拼接）。
 */
export const mapFastTranslateSeriesItemListToTaskItems = (
  list: FastTranslateSeries.FastTranslateSeriesItemListItem[]
): Task.TaskItem[] => {
  const storagePrefix = getVideoStoragePrefix();

  return list.map((item) => {
    const cosUrlRaw = (item.cosUrl ?? "").trim();
    const cosUrl = resolveFastTranslateMediaUrl(cosUrlRaw) || cosUrlRaw;
    const tosUrl = toAbsoluteUrl(item.tosUrl, storagePrefix);
    const coverUrl = toAbsoluteUrl(item.coverUrl, storagePrefix);
    const playUrl = cosUrl || tosUrl;

    let status: number = 4;
    if (item.cosStatus === "PROCESSING") {
      status = 1;
    } else if (item.cosStatus === "FINISH") {
      status = 2;
    } else if (item.cosStatus === "WAITING") {
      status = 4;
    } else if (item.cosStatus === "FAIL") {
      status = 3;
    }

    return {
      name: item.episodeName,
      sourceFileName: item.sourceFileName,
      disable_bgm: false,
      has_user_srt: false,
      has_user_script: false,
      tag: 0,
      descript: item.errorMsg || null,
      id: item.itemId,
      series_id: item.seriesId,
      user_id: 0,
      status,
      create_time: item.createTime,
      update_time: item.updateTime,
      file_url: playUrl,
      source_hls_url: null,
      result_url: playUrl,
      translated_subtitle_url: null,
      subtitle_url: null,
      pure_video_url: tosUrl || null,
      pure_video_hls_url: null,
      cover_url: coverUrl || null,
      backgroud_audio_url: null,
      script_url: null,
      duration: item.duration ?? undefined,
      sourceLanguage: item.sourceLangCode,
      targetLanguage: item.targetLangCode,
      needRemovalSubtitle: item.needRemovalSubtitle,
      episodeTasks: [],
    };
  });
};
